import { render, staticRenderFns } from "./WizardHolder.vue?vue&type=template&id=7f2e38ea&scoped=true&"
import script from "./WizardHolder.vue?vue&type=script&lang=js&"
export * from "./WizardHolder.vue?vue&type=script&lang=js&"
import style0 from "./WizardHolder.vue?vue&type=style&index=0&id=7f2e38ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2e38ea",
  null
  
)

export default component.exports